import { render, staticRenderFns } from "./AvCheckList.vue?vue&type=template&id=25d1aba5&lang=pug"
import script from "./AvCheckList.vue?vue&type=script&lang=ts"
export * from "./AvCheckList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderCheckListItem: require('/app/components/header/CheckListItem.vue').default})
